import { useState, useEffect } from 'react'

const useScrollHideNavbar = (navbarId, top) => {
  const [lastScrollTop, setLastScrollTop] = useState(0)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const navbar = document.getElementById(navbarId)
    if (navbar) {
      navbar.style.transition = 'top 0.3s'
    }
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const navbar = document.getElementById(navbarId)
      if (navbar) {
        if (scrollTop > lastScrollTop) {
          navbar.style.top = `-${top}px`
        } else {
          navbar.style.top = '0'
        }
        setLastScrollTop(scrollTop)
      }
    }

    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    if (windowWidth < 900) {
      window.addEventListener('scroll', handleScroll)
    } else {
      const navbar = document.getElementById(navbarId)
      if (navbar) {
        navbar.style.top = '0'
        window.removeEventListener('scroll', handleScroll)
      }
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleResize)
    }
  }, [lastScrollTop, navbarId, windowWidth])

  return lastScrollTop
}

export default useScrollHideNavbar
